import ConstantHelper from "../../Helpers/ConstantHelper";

const SEOPackagesData = [
  {
    id: "1",
    title: "Identity SEO Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "850",
    actualPrice: "1700",
    featuresList: [
      { feature: "10 Keywords" },
      { feature: "Off-site Optimization" },
      { feature: "On-site Optimization" },
      { feature: "Link Building" },
      { feature: "Social Bookmarking" },
      { feature: "In-depth Site Analysis" },
      { feature: "Content Duplicacy Check" },
      { feature: "Initial Backlinks analysis" },
      { feature: "Google Penalty Check" },
      { feature: "Mobile Usability Check" },
      { feature: "Competition Analysis" },
      { feature: "Keyword Research" },
      { feature: "Title & Meta Tags Optimization" },
      { feature: "Content Optimization" },
      { feature: "Page Speed Analysis & Optimization" },
      { feature: "HTML Code Cleanup & Optimization" },
      { feature: "Internal Link Structuring &Optimization" },
      { feature: "Pages H tags Optimization" },
      { feature: "Canonicalization/301 Redirect" },
      { feature: "Website Page Load Optimization" },
      { feature: "Schema Markup Implementation" },
      { feature: "Image & Hyperlink Optimization" },
      { feature: "Robots.txt Creation/Analysis" },
      { feature: "Blog Writing (2 - Per Month)" },
      { feature: "Informational Content Writing &Sharing (1 Per Month)" },
      { feature: "Press Release Writing &Distribution" },
      { feature: "Press Release Social Bookmarking" },
      { feature: "Google Webmaster Tools Setup" },
      { feature: "Google Analytics Setup &Integration" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Elite SEO Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "1500",
    actualPrice: "3100",
    featuresList: [
      { feature: "20 Keywords" },
      { feature: "Off-site Optimization" },
      { feature: "On-site Optimization" },
      { feature: "Link Building" },
      { feature: "Social Bookmarking" },
      { feature: "In-depth Site Analysis" },
      { feature: "Content Duplicacy Check" },
      { feature: "Initial Backlinks analysis" },
      { feature: "Google Penalty Check" },
      { feature: "Mobile Usability Check" },
      { feature: "Competition Analysis" },
      { feature: "Keyword Research" },
      { feature: "Page Speed Analysis & Optimization" },
      { feature: "Title & Meta Tags Optimization" },
      { feature: "Content Optimization" },
      { feature: "HTML Code Cleanup & Optimization" },
      { feature: "Internal Link Structuring &Optimization" },
      { feature: "Pages H tags Optimization" },
      { feature: "Canonicalization/301 Redirect" },
      { feature: "Website Page Load Optimization" },
      { feature: "Robots.txt Creation/Analysis" },
      { feature: "Press Release Writing &Distribution" },
      { feature: "Press Release Social Bookmarking" },
      { feature: "Schema Markup Implementation" },
      { feature: "Image & Hyperlink Optimization" },
      { feature: "Google Webmaster Tools Setup" },
      { feature: "Google Analytics Setup &Integration" },
      { feature: "Blog Writing (2 - Per Month)" },
      { feature: "Informational Content Writing &Sharing (1 Per Month)" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Professional SEO Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "995",
    actualPrice: "1990",
    featuresList: [
      { feature: "30 Keywords" },
      { feature: "Off-site Optimization" },
      { feature: "On-site Optimization" },
      { feature: "Link Building" },
      { feature: "Social Bookmarking" },
      { feature: "In-depth Site Analysis" },
      { feature: "Content Duplicacy Check" },
      { feature: "Initial Backlinks analysis" },
      { feature: "Google Penalty Check" },
      { feature: "Mobile Usability Check" },
      { feature: "Competition Analysis" },
      { feature: "Keyword Research" },
      { feature: "Page Speed Analysis & Optimization" },
      { feature: "Title & Meta Tags Optimization" },
      { feature: "Content Optimization" },
      { feature: "HTML Code Cleanup & Optimization" },
      { feature: "Internal Link Structuring &Optimization" },
      { feature: "Pages H tags Optimization" },
      { feature: "Canonicalization/301 Redirect" },
      { feature: "Website Page Load Optimization" },
      { feature: "Robots.txt Creation/Analysis" },
      { feature: "Press Release Writing &Distribution" },
      { feature: "Press Release Social Bookmarking" },
      { feature: "Schema Markup Implementation" },
      { feature: "Image & Hyperlink Optimization" },
      { feature: "Google Webmaster Tools Setup" },
      { feature: "Google Analytics Setup &Integration" },
      { feature: "Blog Writing (2 - Per Month)" },
      { feature: "Informational Content Writing &Sharing (1 Per Month)" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Startup SEO Packages",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "450",
    actualPrice: "900",
    featuresList: [
      { feature: "5 Keywords" },
      { feature: "Off-site Optimization" },
      { feature: "Link Building" },
      { feature: "Social Bookmarking" },
      { feature: "Basic Analytical Report" },
      { feature: "In-depth Site Analysis" },
      { feature: "Content Duplicity Check" },
      { feature: "Initial Backlinks analysis" },
      { feature: "Google Penalty Check" },
      { feature: "Mobile Usability Check" },
      { feature: "Competition Analysis" },
      { feature: "Keyword Research" },
      {
        feature: "Informational Content Writing & Sharing (2 - Per Month)",
      },
      { feature: "Blog Writing (1 - Per Month)" },
      { feature: "Press Release Social Bookmarking (5 - Per Month)" },
      { feature: "NAP Syndication" },
      { feature: "Google My Business / Bing Local Listing" },
      { feature: "Citation Building" },
      { feature: "Classified Submissions" },
      { feature: "Google Analytics Analysis Report" },
      { feature: "SEO Reports" },
      { feature: "Search Engine Rank Report" },
      { feature: "Dedicated Accounts Manager" },
      { feature: "Monthly Action Plan" },
      { feature: "Activity Report" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

export default SEOPackagesData;
